import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: `'Inter', 'sans-serif'`,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: "#1C4980",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#155a8a",
          },
        },
        outlined: {
          color: "#1C4980",
          borderColor: "#1C4980",
          "&:hover": {
            backgroundColor: "rgba(28, 117, 188, 0.08)",
            borderColor: "#155a8a",
            color: "#155a8a",
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: "#1C4980",
          },
          "&.Mui-disabled": {
            color: "#757575",
          },
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        disableRipple: true,
        size: "small",
      },
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: "#1C4980",
          },
          "&.Mui-disabled": {
            color: "#757575",
          },
          "&.Mui-checked.Mui-disabled": {
            color: "#757575 !important",
          },
        },
      },
    },
  },
});

export default theme;
